import { combineReducers } from 'redux-immutable'
import { Map, fromJS } from 'immutable';
import trailerReducer from './trailer';



const INIT_STATE = Map();
const SUBSTATE_NAME = "ui";

const combinedReducer = combineReducers({
    trailer: trailerReducer
});

const uiReducer = (state = INIT_STATE, action) => {
    if(action == null) { 
        return state;
    }
    
    const immutableState = fromJS(state)
    const substate = immutableState.get(SUBSTATE_NAME, INIT_STATE)
    const new_substate = combinedReducer(substate, action);
    
    return immutableState.set(SUBSTATE_NAME, new_substate);
}

export default uiReducer;